import { Button } from '@/components/ui/button';
import { FileDown, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface LiquidityPdfExportProps {
  companyId?: string;
  periodDays?: number;
}

export default function LiquidityPdfExport({
  companyId,
  periodDays = 30,
}: LiquidityPdfExportProps) {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState('');

  async function generatePdf() {
    setLoading(true);
    toast('Generating liquidity report...');

    try {
      const { data, error } = await supabase.functions.invoke('generate-liquidity-pdf', {
        body: { companyId: companyId || null, periodDays },
      });

      if (error) throw error;

      const reportUrl = data?.url || '';
      setUrl(reportUrl);
      toast.success('PDF generated successfully');

      // Open the report in a new tab
      if (reportUrl) {
        window.open(reportUrl, '_blank');
      }
    } catch (error: any) {
      console.error('Error generating PDF:', error);
      toast.error(error.message || 'Failed to generate PDF');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex gap-2 items-center">
      <Button onClick={generatePdf} disabled={loading} variant="outline">
        {loading ? (
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        ) : (
          <FileDown className="h-4 w-4 mr-2" />
        )}
        Download PDF
      </Button>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-primary hover:underline"
        >
          Open latest report
        </a>
      )}
    </div>
  );
}
